



































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private masterFieldSort (name: string) {
    this.$emit('master-field-sort', name)
  }
}
